
export type AiProviderId = 'openai' | 'anthropic' | 'gemini' | 'custom';

export interface AiModel {
  id: string;
  name: string;
}

export interface ChatMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  timestamp: number;
}

export interface AiConfig {
  provider: AiProviderId;
  model: string;
  customBaseUrl?: string;
  includeContext: boolean;
  includeSensitive: boolean;
}

export const DEFAULT_MODELS: Record<AiProviderId, AiModel[]> = {
  openai: [
    { id: 'gpt-4o-mini', name: 'GPT-4o Mini' },
    { id: 'gpt-4o', name: 'GPT-4o' },
    { id: 'gpt-3.5-turbo', name: 'GPT-3.5 Turbo' }
  ],
  anthropic: [
    { id: 'claude-3-5-haiku-20241022', name: 'Claude 3.5 Haiku' },
    { id: 'claude-3-5-sonnet-20241022', name: 'Claude 3.5 Sonnet' }
  ],
  gemini: [
    { id: 'gemini-1.5-flash', name: 'Gemini 1.5 Flash' },
    { id: 'gemini-1.5-pro', name: 'Gemini 1.5 Pro' }
  ],
  custom: [
    { id: 'custom-model', name: 'Custom Model' }
  ]
};

export const QUICK_ACTIONS = [
  { id: 'tasks', label: 'Navrhni úkoly', prompt: 'Navrhni 5 nejdůležitějších úkolů pro aktuální fázi příprav.' },
  { id: 'schedule', label: 'Harmonogram dne', prompt: 'Navrhni orientační harmonogram svatebního dne (od příprav po večerní zábavu).' },
  { id: 'ceremony_script', label: 'Scénář obřadu', prompt: 'Navrhni detailní scénář svatebního obřadu včetně proslovu oddávajícího.' },
  { id: 'ring_engraving', label: 'Text rytiny', prompt: 'Navrhni 10 originálních textů pro rytinu do snubních prstenů (krátké, do 20 znaků).' },
  { id: 'budget', label: 'Rozpočet kategorií', prompt: 'Navrhni procentuální rozdělení rozpočtu do hlavních kategorií (jídlo, místo, oblečení, atd.).' },
  { id: 'invite', label: 'Text pozvánky', prompt: 'Napiš 3 varianty textu na svatební oznámení (formální, vtipné, veršované).' },
];
